import { c as _c } from "react/compiler-runtime";
import type { AlgoliaIndexItem } from '@algoacademy/backend/modules/docs/external-functions/queries/algolia-index-item-type';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { TextDecorator } from '@algoacademy/design-system/web/atoms/TextDecorator';
import { P2, P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { Highlight, useHits, useSearchBox } from 'react-instantsearch';
import { RecentSearches } from '@/app/baza/_components/Search/_components/SearchResult/RecentSearches';
import { saveRecentSearch } from '@/app/baza/_components/Search/_components/SearchResult/RecentSearches/recentSearchesStorage';
import { TopHits } from '@/app/baza/_components/Search/_components/SearchResult/TopHits';
export function GeneralSearchResult() {
  const $ = _c(18);
  const {
    query
  } = useSearchBox();
  const {
    items: hits
  } = useHits();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== hits || $[1] !== query) {
    const q = query?.trim().toLowerCase() || "";
    const collectionHits = [...new Map(hits.filter(hit => q && hit.collection?.name.toLowerCase().includes(q)).map(_temp)).values()];
    const articleHits = hits.filter(hit_1 => q && hit_1.article?.name.toLowerCase().includes(q));
    const hasHits = collectionHits.length > 0 || articleHits.length > 0;
    t0 = "flex w-full flex-col gap-6 py-6";
    if ($[7] !== query) {
      t1 = !query && <RecentSearches />;
      $[7] = query;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    if ($[9] !== hasHits || $[10] !== query) {
      t2 = query && !hasHits && <div className="flex flex-col gap-4"><P2 className="text-center text-contentInverseTertiary">Brak dopasowań dla "{query}"</P2><TopHits /></div>;
      $[9] = hasHits;
      $[10] = query;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t3 = collectionHits.length > 0 && <div><P2 className="font-semibold text-contentSecondary">Kolekcje</P2><div className="mt-2 flex flex-col gap-3">{collectionHits.map(_temp2)}</div></div>;
    t4 = articleHits.length > 0 && <div><P2 className="font-semibold text-contentSecondary">Artykuły</P2><div className="mt-2 flex flex-col gap-3">{articleHits.map(_temp3)}</div></div>;
    $[0] = hits;
    $[1] = query;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className={t0}>{t1}{t2}{t3}{t4}</div>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function _temp3(hit_3) {
  return <Link key={hit_3.article.id} href={`/baza/${hit_3.collection.slug}/${hit_3.article.slug}`} className="group rounded-lg bg-backgroundSecondary px-3 py-3 hover:bg-backgroundBlue hover:text-contentBlue" onClick={() => saveRecentSearch(hit_3)}><P2 className="text-current"><Highlight hit={hit_3} attribute={["article", "name"]} classNames={{
        highlighted: "font-bold bg-transparent text-current"
      }} /></P2><P3 className="mt-1 text-contentTertiary group-hover:text-contentBlue">{hit_3.collection.name}</P3></Link>;
}
function _temp2(hit_2) {
  return <Link key={hit_2.collection.id} href={`/baza/${hit_2.collection.slug}`} className="group rounded-lg border border-borderPrimary bg-backgroundSecondary px-3 py-3 hover:border-backgroundBlue hover:bg-backgroundBlue hover:text-contentBlue"><P2><TextDecorator gradientColor={hit_2.collection.gradientColor}><Highlight hit={hit_2} attribute={["collection", "name"]} classNames={{
          highlighted: "font-bold bg-transparent text-current"
        }} /></TextDecorator></P2>{hit_2.collection?.description && <P3 className="mt-1 text-contentTertiary group-hover:text-contentBlue">{hit_2.collection.description}</P3>}</Link>;
}
function _temp(hit_0) {
  return [hit_0.collection.id, hit_0];
}